import React from "react";
import {
  Box,
  makeStyles,
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
  useTheme
} from "@material-ui/core";

import I18nText from "../../elements/I18nText";

const useStyles = makeStyles(theme => ({
  header: {
    fontWeight: 600,
    whiteSpace: "nowrap"
  },
  compactColumn: {
    width: "5%",
    minWidth: 60
  },
  smallColumn: {
    width: "8%",
    minWidth: 80
  },
  mediumColumn: {
    width: "10%",
    minWidth: 100
  },
  largeColumn: {
    width: "12%",
    minWidth: 120
  },
  sensorsColumn: {
    width: "60%",
    minWidth: 300,
    [theme.breakpoints.down("lg")]: {
      width: "35%"
    },
    [theme.breakpoints.down("md")]: {
      width: "30%"
    }
  }
}));

const TableHeader = ({ sort, onUpdateSort, tableColumns }) => {
  const classes = useStyles();
  const theme = useTheme();
  const showColumn = column => tableColumns.indexOf(column) !== -1;

  const sorted = by => sort.by === by;

  return (
    <TableHead>
      <TableRow>
        {showColumn("id") && (
          <TableCell className={`${classes.header} ${classes.compactColumn}`}>
            <TableSortLabel
              active={sorted("id")}
              direction={sorted("id") && sort.desc ? "desc" : "asc"}
              onClick={() => onUpdateSort("id")}
            >
              <I18nText>devices.list.table.header.id</I18nText>
            </TableSortLabel>
          </TableCell>
        )}
        {showColumn("username") && (
          <TableCell
            className={`${classes.header} ${classes.mediumColumn}`}
            align="center"
          >
            <TableSortLabel
              active={sorted("username")}
              direction={sorted("username") && sort.desc ? "desc" : "asc"}
              onClick={() => onUpdateSort("username")}
            >
              <I18nText>devices.list.table.header.user</I18nText>
            </TableSortLabel>
          </TableCell>
        )}
        {showColumn("name") && (
          <TableCell
            className={`${classes.header} ${classes.mediumColumn}`}
            align="center"
          >
            <TableSortLabel
              active={sorted("name")}
              direction={sorted("name") && sort.desc ? "desc" : "asc"}
              onClick={() => onUpdateSort("name")}
            >
              <I18nText>devices.list.table.header.name</I18nText>
            </TableSortLabel>
          </TableCell>
        )}
        {showColumn("project") && (
          <TableCell
            className={`${classes.header} ${classes.mediumColumn}`}
            align="center"
          >
            <TableSortLabel
              active={sorted("project")}
              direction={sorted("project") && sort.desc ? "desc" : "asc"}
              onClick={() => onUpdateSort("project")}
            >
              <I18nText>devices.list.table.header.project</I18nText>
            </TableSortLabel>
          </TableCell>
        )}

        {showColumn("countryCode") && (
          <TableCell className={`${classes.header} ${classes.compactColumn}`}>
            <TableSortLabel
              active={sorted("address.countryCode")}
              direction={
                sorted("address.countryCode") && sort.desc ? "desc" : "asc"
              }
              onClick={() => onUpdateSort("address.countryCode")}
            >
              <I18nText>devices.list.table.header.countryCode</I18nText>
            </TableSortLabel>
          </TableCell>
        )}
        {showColumn("postalCode") && (
          <TableCell className={`${classes.header} ${classes.smallColumn}`}>
            <TableSortLabel
              active={sorted("address.postalCode")}
              direction={
                sorted("address.postalCode") && sort.desc ? "desc" : "asc"
              }
              onClick={() => onUpdateSort("address.postalCode")}
            >
              <I18nText>devices.list.table.header.postalCode</I18nText>
            </TableSortLabel>
          </TableCell>
        )}
        {showColumn("city") && (
          <TableCell
            className={`${classes.header} ${classes.mediumColumn}`}
            align="center"
          >
            <TableSortLabel
              active={sorted("address.city")}
              direction={sorted("address.city") && sort.desc ? "desc" : "asc"}
              onClick={() => onUpdateSort("address.city")}
            >
              <I18nText>devices.list.table.header.city</I18nText>
            </TableSortLabel>
          </TableCell>
        )}
        {showColumn("street") && (
          <TableCell
            className={`${classes.header} ${classes.largeColumn}`}
            align="center"
          >
            <TableSortLabel
              active={sorted("address.street")}
              direction={sorted("address.street") && sort.desc ? "desc" : "asc"}
              onClick={() => onUpdateSort("address.street")}
            >
              <I18nText>devices.list.table.header.street</I18nText>
            </TableSortLabel>
          </TableCell>
        )}
        {showColumn("lastReportedAt") && (
          <TableCell
            className={`${classes.header} ${classes.largeColumn}`}
            align="center"
          >
            <TableSortLabel
              active={sorted("lastReportedAt")}
              direction={sorted("lastReportedAt") && sort.desc ? "desc" : "asc"}
              onClick={() => onUpdateSort("lastReportedAt")}
            >
              <I18nText>devices.list.table.header.lastReportedAt</I18nText>
            </TableSortLabel>
          </TableCell>
        )}
        {showColumn("simCredit") && (
          <TableCell className={`${classes.header} ${classes.smallColumn}`}>
            <I18nText>devices.list.table.header.simCredit</I18nText>
          </TableCell>
        )}
        {showColumn("status") && (
          <TableCell
            align="center"
            className={`${classes.header} ${classes.mediumColumn}`}
          >
            <I18nText>devices.list.table.header.status</I18nText>
          </TableCell>
        )}

        <TableCell
          align="center"
          className={`${classes.header} ${classes.sensorsColumn}`}
        >
          <Box component="span" color={theme.palette.text.primary}>
            <I18nText>devices.list.table.header.values</I18nText>
          </Box>{" "}
          |{" "}
          <Box component="span" color={theme.palette.text.primary}>
            <I18nText>devices.list.table.header.medium</I18nText>
          </Box>
        </TableCell>
      </TableRow>
    </TableHead>
  );
};

export default TableHeader;
